
import React, { useState, useEffect } from "react";
import { CheckCircle } from "lucide-react";
import { Input } from "@/components/ui/input";

// Input Field with Validation Check
interface ValidatedInputProps {
  id: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  type?: string;
  min?: string;
  max?: string;
}

const ValidatedInput = ({ id, value, onChange, placeholder, type = "text", min, max }: ValidatedInputProps) => {
  const [isFilled, setIsFilled] = useState(false);
  
  useEffect(() => {
    setIsFilled(value.trim().length > 0);
  }, [value]);
  
  return (
    <div className="relative">
      <Input
        id={id}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        type={type}
        min={min}
        max={max}
        className="bg-white text-black pr-10 border-gray-300"
      />
      {isFilled && (
        <CheckCircle className="absolute right-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-green-500" />
      )}
    </div>
  );
};

export default ValidatedInput;
